// Manifest of blog posts. The index page reads this to render cards. Each
// `slug` corresponds to a .tsx file in this directory. When adding a new post:
//   1. Add an entry here
//   2. Create app/(auth)/blog/<slug>.tsx
//   3. Add a meta override in scripts/inject-per-page-meta.js for SEO
export interface PostMeta {
  slug: string;
  title: string;
  excerpt: string;
  date: string;          // YYYY-MM-DD
  category: string;
  readMinutes: number;
  featuredImage?: string; // absolute path under /public, e.g. "/blog/foo.jpg"
}

export const POSTS: PostMeta[] = [
  {
    slug: "how-to-calculate-fast-cat-points",
    title: "How to Calculate Fast CAT Points",
    excerpt: "The exact scoring formula — MPH × height handicap — with worked examples for a big dog and a small one, how points become titles, and a free calculator so you never have to do it by hand.",
    date: "2026-08-11",
    category: "Scoring",
    readMinutes: 6,
    featuredImage: "/blog/phil-teton-fast-cat.jpg",
  },
  {
    slug: "how-to-train-your-dog-for-fast-cat",
    title: "How to Train Your Dog for Fast CAT",
    excerpt: "A step-by-step guide to building drive, conditioning your dog, and getting them to chase a lure all 100 yards on event day — even if they've never seen one before.",
    date: "2026-06-14",
    category: "Training",
    readMinutes: 8,
    featuredImage: "/blog/mogwai-chasing-lure.jpg",
  },
];
